import {
    Box,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Typography,
    SelectProps,
} from "@mui/material";

import "../components-styles.scss";

type ValueType = string | number | undefined;

export type DropDownItem = {
    id: ValueType;
    name: string;
    name2?: string;
    code?: string;
};

type DropDownProps = {
    items: DropDownItem[];
    inputlabel: string;
    errortext?: string;
    onChange: Function;
    sublabel?: string;
    selectpx?: object;
    root?: any;
};

export default function DropDown(props: SelectProps & DropDownProps) {
    const { items, inputlabel, errortext, selectpx, root } = props;

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: "0.5rem",
                width: root?.width ?? "100%",
                ...root,
            }}
        >
            {inputlabel ? (
                <InputLabel
                    sx={{
                        fontSize: 16,
                        fontFamily: "Roboto",

                        color: "#023",
                        fontStyle: "normal",
                        fontWeight: "500",
                        lineHeight: "160%",
                    }}
                >
                    {inputlabel}
                </InputLabel>
            ) : null}
            {props.sublabel ? (
                <Typography
                    sx={{
                        color: "#023",
                        fontFamily: "Roboto",
                        fontSize: "0.75rem",
                        fontStyle: "normal",
                        fontWeight: 400,
                        lineHeight: "130%",
                    }}
                >
                    {props.sublabel}
                </Typography>
            ) : null}
            <FormControl>
                <Select
                    {...props}
                    sx={{
                        "& .MuiInputBase-input-MuiOutlinedInput-input": {
                            padding: "17px 16px",
                        },
                        display: "flex",
                        flex: "1 0 0",
                        alignItems: "center",
                        gap: "8px",
                        alignSelf: "stretch",
                        borderRadius: "16px",
                        background: "#FFF",
                        "& .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                        },
                        "&.MuiPaper-root-MuiPopover-paper-MuiMenu-paper": {
                            display: "flex",
                            padding: "1.0625rem 1rem",
                            alignItems: "center",
                            gap: "0.5rem",
                            alignSelf: "stretch",
                            borderRadius: "1rem",
                            border: "2px solid #E3E6E8",
                            background: "#FFF",
                            flexDirection: "column",
                        },
                        ...selectpx,
                    }}
                    MenuProps={{
                        classes: {
                            paper: "dropDown-menu-list",
                        },
                    }}
                    inputProps={{ "aria-label": "Without label" }}
                >
                    {items.map((item: DropDownItem) => (
                        <MenuItem
                            key={item.id}
                            value={item.id}
                            sx={{
                                justifyContent: "space-between",
                            }}
                        >
                            <Typography
                                sx={{
                                    color: "#023",
                                    fontFamily: "Roboto",
                                    fontSize: "1rem",
                                    fontStyle: "normal",
                                    fontWeight: "400",
                                    lineHeight: "160%",
                                }}
                            >
                                {item.name}
                            </Typography>
                            {item.name2 ? (
                                <Typography
                                    sx={{
                                        color: "#555A5D",
                                        textAlign: "left",
                                        fontFamily: "Roboto",
                                        fontSize: "0.75rem",
                                        fontStyle: "normal",
                                        fontWeight: "400",
                                        lineHeight: "130%",
                                        //position: "absolute",
                                        //right: "1rem",
                                        //float: "right",
                                    }}
                                >
                                    {item.name2}
                                </Typography>
                            ) : (
                                ""
                            )}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            {errortext ? (
                <Typography
                    sx={{
                        fontSize: {
                            xs: "15px",
                            md: "17px",
                        },
                        fontWeight: "600",
                        fontFamily: "Gotham Book",
                        marginBottom: "10px",
                    }}
                    color="#E51846"
                >
                    {errortext ?? ""}
                </Typography>
            ) : (
                <></>
            )}
        </Box>
    );
}
